import { Outlet } from 'react-router-dom'

// This is only used by the AppStore settings view, and it should be removed when the AppStore is completely removed
export const AtsSettingsAppStoreRootPage = () => {
  return <Outlet />
}
